import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Layout from "../../../layout";
import { Box } from "@material-ui/core";
import TitlePage from '../../common/TitlePage';
import Table from "./table";
import { convertNumberToPersian } from "../../method/convertDigitToEnglish";
import { distinctMethod } from './../../method/distinctMethod'

const useStyles = makeStyles((theme) => ({
    root: {
        minHeight: '60vh',
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: 'column',
        paddingTop: 20,
    },
    gridTitle: {
        width: '50%',
        textAlign: 'left',
    },
    details: {
        width: '100%',
        margin: 'auto',
        borderRadius: 15,
        padding: "20px 27px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: 'column',
        [theme.breakpoints.down('sm')]: {
            width: "98%",
        }
    },
    item: {
        display: "flex",
        alignItems: "center",
        flexDirection: 'column',
        color: "black",
        textAlign: 'right',
        overflow: 'auto',
        maxWidth: '100%',
        width: '60%',
        [theme.breakpoints.down('sm')]: {
            width: "98%",
        }
    },
    color: {
        color: theme.palette.light.type2
    },

}));

export default function Index() {

    const classes = useStyles();
    const [state, setState] = useState([]);


    useEffect(() => {
        let category = dataStatic?.length ? distinctMethod(dataStatic, ["title"]) : []
        let res = category?.map((key => {
            return ({
                id: key,
                body: dataStatic?.filter((item) => (item?.title === key))
            })
        }))
        setState(res)
    }, [dataStatic]);



    return (
        <Layout>
            <div className={classes['root']}>
                {
                    state
                        ?.map((item) => {
                            return (
                                <div className={classes.details}>
                                    <Box className={classes.item}>
                                        <Table head={head} data={item} />
                                    </Box>
                                </div>
                            )
                        })
                }
            </div>
        </Layout>
    );
}

const head = [
    // {
    //     key: 1,
    //     id: "title",
    //     label: "عنوان",
    //     minWidth: 120,
    //     align: "center",
    // },
    {
        id: "titleBank",
        label: "نام بانک",
        minWidth: 100,
        align: "center",
        format: (value) => convertNumberToPersian(value),
    },
    {
        id: "accountNumber",
        label: "شماره حساب",
        minWidth: 150,
        align: "left",
        format: (value) => convertNumberToPersian(value),
    },
    {
        id: "shaba",
        label: "شبا",
        minWidth: 270,
        align: "center",
        format: (value) => convertNumberToPersian(value),
    },
    {
        id: "shoab",
        label: "شعبه",
        minWidth: 220,
        align: "center",
        format: (value) => convertNumberToPersian(value),
    },
    {
        id: "codeShaba",
        label: "کد شعبه",
        minWidth: 50,
        align: "center",
        format: (value) => convertNumberToPersian(value),
    },


];


let dataStatic = [

    {
        title: "اوراق بهادار",
        accountNumber: "10.9143608.1",
        shaba: "IR39 0700 0010 0022 9143 6080 01",
        codeShaba: "10",
        shoab: "بانکداری اجتماعی",
        titleBank: "رسالت",
    },
    {
        title: "اوراق بهادار",
        accountNumber: "104351492",
        shaba: "IR72 0180 0000 0000 0104 3514 92",
        codeShaba: "1043",
        shoab: "تخصصی بورس کالا",
        titleBank: "تجارت",
    },
    {
        title: "اوراق بهادار",
        accountNumber: "849.40.3946539.1",
        shaba: "IR66 0560 0849 0400 3946 5390 01",
        codeShaba: "866",
        shoab: "سرو",
        titleBank: "سامان",
    },
    {
        title: "اوراق بهادار",
        accountNumber: "9602359061",
        shaba: "IR41 0120 0000 0000 9602 3590 61",
        codeShaba: "62117",
        shoab: "بورس کالا",
        titleBank: "ملت",
    },
    {
        title: "اوراق بهادار",
        accountNumber: "321.110.16391985.1",
        shaba: "IR59 0570 0321 1101 6391 9850 01",
        codeShaba: "110",
        shoab: "نامجو",
        titleBank: "پاسارگاد",
    },
    // {
    //     title: "اوراق بهادار",
    //     accountNumber: "1001002331638",
    //     shaba: "IR81 0610 0000 0100 1002 3316 38",
    //     codeShaba: "234",
    //     shoab: "سعادت آباد",
    //     titleBank: "شهر",
    // },
        // {
    //     title: "اوراق بهادار",
    //     accountNumber: "207.110.16391985.1",
    //     shaba: "IR39 0570 0207 1101 6391 9850 01",
    //     codeShaba: "207",
    //     shoab: "میدان هفت تیر",
    //     titleBank: "پاسارگاد",
    // },

    {
        title: "بورس کالا",
        accountNumber: "104351301",
        shaba: "IR88 0180 0000 0000 0104 3513 01",
        codeShaba: "1043",
        shoab: "تخصصی بورس کالا",
        titleBank: "تجارت",
    },

    {
        title: "بورس کالا",
        accountNumber: "849.40.3946539.2",
        shaba: "IR39 0560 0849 0400 3946 5390 02",
        codeShaba: "866",
        shoab: "سرو",
        titleBank: "سامان",
    },
    {
        title: "بورس کالا",
        accountNumber: "9602392068",
        shaba: "IR88 0120 0000 0000 9602 3920 68",
        codeShaba: "62117",
        shoab: "بورس کالا",
        titleBank: "ملت",
    },
    {
        title: "بورس کالا",
        accountNumber: "0116456335005",
        shaba: "IR37 0170 0000 0011 6456 3350 05",
        codeShaba: "1700695",
        shoab: "بورس کالا",
        titleBank: "ملي",
    },
    {
        title: "اوراق بهادار",
        accountNumber: "1001002680659",
        shaba: "IR64 0610 0000 0100 1002 6806 59",
        codeShaba: "336",
        shoab: "دولت",
        titleBank: "شهر",
    },
    {
        title: "اوراق بهادار",
        accountNumber: "0116420795008",
        shaba: "IR84 0170 0000 0011 6420 7950 08",
        codeShaba: "1700695",
        shoab: "بورس اوراق بهادار",
        titleBank: "ملی",
    },

    
    {
        title: "بورس انرژی",
        accountNumber: "9687436859",
        shaba: "IR48 0120 0000 0000 9687 4368 59",
        codeShaba: "62117",
        shoab: "بورس كالا",
        titleBank: "ملت",
    },

    // {
    //     title: "",
    //     accountNumber: "",
    //     shaba: "",
    //     codeShaba: "",
    //     shoab: "",
    //     titleBank: "",
    // },

]
